<div class="Content_outer" #divToScroll>
  <div class="content_view">
    <div class="row">
      <div class="col-md-12">
        <div class="newform_outer">
          <div class="filter_div">
            <div class="top">
              <h4>Boiler Configurator</h4>
            </div>
          </div>
          <div class="field_both_side">
            <div class="left_side" style="text-align: center;">
              <div class="inner">
                <div
                >
                <h4 style="font-weight: 700; padding: 20px">Asset Templates</h4>
                <img style="width: 200px;" src="../../assets/products-coil-tube-steam-boiler.png" alt="boiler-image">
                </div>
              </div>
            </div>
            <div class="right_side">
              <div class="row">
                <div class="col-md-12 col">
                  <form [formGroup]="boilerForm" (ngSubmit)="onSubmit()">
                    <div class="row">
                      <div class="col-md-6 col">
                        <label
                          >Boiler Name *<span class="material-icons info" ngbPopover="Boiler Name, given by the Client, e.g. Mixer Motor 1" triggers="mouseenter:mouseleave">info</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="boiler_name"
                          formControlName="boiler_name"
                          disabled="true"
                        />
                      </div>

                      <div class="col-md-6 col">
                        <label
                          >Serial Number *<span
                            class="material-icons info"
                            ngbPopover="Boiler serial number"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id = "serial_number"
                          formControlName = "serial_number"
                          disabled
                        />
                      </div>
                      
                    </div>
                    <div class="row">
                      <div class="col-md-6 col">
                        <label
                          >Site *<span
                            class="material-icons info"
                            ngbPopover="Client Site, e.g. Hamilton Site"
                            triggers="mouseenter:mouseleave"
                            >info</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id = "site_name"
                          formControlName = "site_name"
                          disabled="true"
                        />
                      </div>
                    <div class="col col-md-6">
                      <label
                      >Application *<span
                        class="material-icons info"
                        ngbPopover="Name of the Application, given by the Client, e.g. Scrubber Application"
                        triggers="mouseenter:mouseleave"
                        >info</span
                      ></label
                    >
                      <input
                        type="text"
                        class="form-control"
                        id = "application_name"
                        formControlName = "application_name"
                        disabled="true"
                      />
                    </div>
                    </div>
                    <hr>

                    <div class="row">
                      <div class="col-md-6 col">
                        <label
                        >Address *<span
                          class="material-icons info"
                          ngbPopover="Site's address"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label>
                        <input
                          type="text"
                          class="form-control"
                          id="address"
                          formControlName="address"
                          disabled="true"
                        />
                      </div>
                    </div>
                    <div class="row">
                    <div class="col-md-6 col">
                      <label
                      >Country
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="country_name"
                        formControlName="country_name"
                        disabled="true"
                      />
                    </div>
                    <div class="col-md-6 col">
                      <label
                      >State</label>
                      <input
                        type="text"
                        class="form-control"
                        id="state_name"
                        formControlName="state_name"
                        disabled="true"
                      />
                    </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col">
                        <label>
                          Latitude
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id = "latitude"
                          formControlName = "latitude"
                          disabled="true"
                        />
                      </div>
                      <div class="col-md-6 col">
                        <label
                        >Longitude</label>
                        <input
                          type="text"
                          class="form-control"
                          id="longitude"
                          formControlName="longitude"
                          disabled="true"
                        />
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-md-6 col">
                        <label
                        >Device Serial *<span
                          class="material-icons info"
                          ngbPopover="Device serial number"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label>
                        <input
                          type="text"
                          class="form-control"
                          id = "device_serial"
                          formControlName = "device_serial"
                          [disabled]="applicationName"
                        />
                      </div>
                      <div class="col-md-6 col">
                        <label
                        >Gateway Address *<span
                          class="material-icons info"
                          ngbPopover="Gateway address i"
                          triggers="mouseenter:mouseleave"
                          >info</span
                        ></label>
                        <input
                          type="text"
                          class="form-control"
                          id="gateway_address"
                          formControlName="gateway_address"
                          [disabled]="applicationName"
                        />
                      </div>
                    </div> -->
                    <div class="boxes_outer" style="display: inline-block;">
                    <div *ngIf="showEmptyError !== ''; else deviceAvailable" style="border: 1px solid black;" class="box">
                      <img src="../../assets/motor_n.png" alt="device-img" class="grayscale">
                    </div>
                    <div class="content_view" >
                      <div class="row" #deviceAvailable>
                        <div class="boxes_outer">
                          <div class="box">
                            <div
                                *ngFor="let device of allDeviceSecondArray; let i = index"
                                style="height: 186px !important"
                                class="box green_bg"
                                [style.background-color]="device.color"
                              >
                                <div class="statusSymbol">
                                  <span
                                    *ngIf="[0,2].includes(device.asset_status)"
                                    class="seen"
                                  >
                                    <img
                                      matTooltip="Asset Idle"
                                      style="height: 10px; width: 10px"
                                      src="./assets/images/red.png"
                                      [matTooltipClass]="'tooltip1'"
                                  /></span>

                                  <span *ngIf="device.asset_status === 1" class="seen">
                                    <img
                                      matTooltip="Asset Running"
                                      style="height: 10px; width: 10px"
                                      src="./assets/images/green.png"
                                      [matTooltipClass]="'tooltip1'"
                                    />
                                  </span>
                                </div>
                                <div class="data">
                                  <h4 class="name bl_color">{{ device.name }}</h4>
                                  <p
                                    class="num"
                                    *ngFor="let sensor of device.connected_sensors; let i = index"
                                  >
                                    {{
                                      i === 0
                                        ? sensor.motor_serial_no
                                        : ", " + sensor.motor_serial_no.substr(-4)
                                    }}
                                  </p>
                                </div>

                                <div
                                  *ngIf="device.new !== undefined"
                                  class="{{ device.asset_type_s }} motorView EditView {{
                                    device.asset_type
                                  }}"
                                >
                                  <div class="motor left {{ device.asset_type }}">
                                    <span
                                      class="left"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="
                                          sensor.parent === 'primary' && sensor.sensor === 'nde'
                                        "
                                        (click)="openDetailScreen(sensor, device)"
                                        matTooltip="{{ sensor.motor_serial_no }}"
                                        [style.background-color]="sensor.color"
                                        class="numBtn"
                                      >
                                        {{ sensor.sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <span
                                      class="center"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="
                                          sensor.parent === 'primary' && sensor.sensor === 'frame'
                                        "
                                        (click)="openDetailScreen(sensor, device)"
                                        matTooltip="{{ sensor.motor_serial_no }}"
                                        [style.background-color]="sensor.color"
                                        class="numBtn"
                                      >
                                        {{ sensor.sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <span
                                      class="right"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="
                                          sensor.parent === 'primary' && sensor.sensor === 'de'
                                        "
                                        (click)="openDetailScreen(sensor, device)"
                                        matTooltip="{{ sensor.motor_serial_no }}"
                                        [style.background-color]="sensor.color"
                                        class="numBtn"
                                      >
                                        {{ sensor.sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <img src="{{ device.imgP }}" />
                                  </div>

                                  <div
                                    class=" motor right {{ device.asset_type_s }}"
                                    *ngIf="device.asset_type_s"
                                  >
                                    <span
                                      class="left coupleLeft"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="
                                          sensor.parent === 'primary' &&
                                          sensor.sensor === 'couple'
                                        "
                                        (click)="openDetailScreen(sensor, device)"
                                        matTooltip="{{ sensor.motor_serial_no }}"
                                        [style.background-color]="sensor.color"
                                        class="numBtn"
                                      >
                                        {{ sensor.sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <span
                                      class="left"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="
                                          sensor.parent === 'secondry' && sensor.sensor === 'de'
                                        "
                                        (click)="openDetailScreen(sensor, device)"
                                        matTooltip="{{ sensor.motor_serial_no }}"
                                        [style.background-color]="sensor.color"
                                        class="numBtn"
                                      >
                                        {{ sensor.sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <span
                                      class="center"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="
                                          sensor.parent === 'secondry' &&
                                          sensor.sensor === 'frame'
                                        "
                                        (click)="openDetailScreen(sensor, device)"
                                        matTooltip="{{ sensor.motor_serial_no }}"
                                        [style.background-color]="sensor.color"
                                        class="numBtn"
                                      >
                                        {{ sensor.sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <span
                                      class="right"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="
                                          sensor.parent === 'secondry' && sensor.sensor === 'nde'
                                        "
                                        (click)="openDetailScreen(sensor, device)"
                                        matTooltip="{{ sensor.motor_serial_no }}"
                                        [style.background-color]="sensor.color"
                                        class="numBtn"
                                      >
                                        {{ sensor.sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <img src="{{ device.imgS }}" />
                                  </div>
                                </div>

                                <div class="motorView" *ngIf="device.template_id === '1'">
                                  <div class="motor left {{ device.asset_type }}">
                                    <span
                                      class="center_single"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 1"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                  </div>
                                </div>

                                <div class="motorView" *ngIf="device.template_id === '4'">
                                  <div class="motor left {{ device.asset_type }}">
                                    <span
                                      class="left"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 2"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <span
                                      class="center"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 1"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                        <span
                                          *ngIf="sensor.asset_status === 2"
                                          class="sprite_iconred wifiIcon wifi_redlabel"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 1"
                                          class="sprite_icon wifiIcon wifi_ys"
                                        ></span>
                                        <span
                                          *ngIf="sensor.asset_status === 0"
                                          class="sprite_icon wifiIcon wifi_na"
                                        ></span></button
                                    ></span>
                                    <span
                                      class="right"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 3"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                        <span *ngIf="sensor.asset_status === 2" class="wifiIcon"
                                          ><i class="fa fa-wifi"></i
                                        ></span>
                                        <span *ngIf="sensor.asset_status === 1" class="wifiIcon"
                                          ><i class="fa fa-wifi"></i
                                        ></span>
                                        <span *ngIf="sensor.asset_status === 0" class="wifiIcon"
                                          ><i class="fa fa-wifi"></i
                                        ></span></button
                                    ></span>

                                    <img
                                      *ngIf="device.asset_type === 'MOTOR'"
                                      src="./assets/motor_n.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'GEAR'"
                                      src="./assets/gearbox.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'PUMP'"
                                      src="./assets/pump.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'FAN_BLOWER'"
                                      src="./assets/fan.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                                      src="./assets/bearing2.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'COMPRESSOR'"
                                      src="./assets/compressor.png"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="motorView {{ device.asset_type }}"
                                  *ngIf="device.template_id === '5'"
                                >
                                  <div class="motor left">
                                    <span
                                      class="left_t6_de"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 2"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                    <span
                                      class="center"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 1"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                    <span
                                      class="right_t6_nde"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 3"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                    <img src="./assets/motor_n.png" />

                                    <img
                                      *ngIf="device.asset_type === 'GEAR'"
                                      src="./assets/gearbox.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'PUMP'"
                                      src="./assets/pump.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'FAN_BLOWER'"
                                      src="./assets/fan.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                                      src="./assets/bearing2.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'COMPRESSOR'"
                                      src="./assets/compressor.png"
                                    />
                                  </div>
                                  <div class="motor right {{ device.asset_type }}">
                                    <img
                                      *ngIf="device.asset_type === 'MOTOR'"
                                      src="./assets/motor_n.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'GEAR'"
                                      src="./assets/gearbox.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'PUMP'"
                                      src="./assets/pump.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'FAN_BLOWER'"
                                      src="./assets/fan.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                                      src="./assets/bearing2.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'COMPRESSOR'"
                                      src="./assets/compressor.png"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="motorView {{ device.asset_type }}"
                                  *ngIf="device.template_id === '7'"
                                >
                                  <div class="motor left">
                                    <span
                                      class="left"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 2"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                    <span
                                      class="center"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 1"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                    <span
                                      class="right"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 3"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                    <img src="./assets/motor_n.png" />
                                  </div>
                                  <div class="motor right {{ device.asset_type }}">
                                    <img
                                      *ngIf="device.asset_type === 'MOTOR'"
                                      src="./assets/motor_n.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'GEAR'"
                                      src="./assets/gearbox.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'PUMP'"
                                      src="./assets/pump.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'FAN_BLOWER'"
                                      src="./assets/fan.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'JOURNAL_BEARING'"
                                      src="./assets/bearing2.png"
                                    />
                                    <img
                                      *ngIf="device.asset_type === 'COMPRESSOR'"
                                      src="./assets/compressor.png"
                                    />
                                    <span
                                      class="left"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 4"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                    <span
                                      class="right"
                                      *ngFor="let sensor of device.connected_sensors"
                                      ><button
                                        *ngIf="sensor.device_sno === 5"
                                        (click)="openDetailScreen(sensor, device)"
                                        [style.background-color]="sensor.color"
                                      >
                                        {{ sensor.device_sno }}
                                      </button></span
                                    >
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div class="form_actions">
                    <span>
                      <button
                        class="primary_btn"
                        mat-raised-button
                        type="button"
                        (click)="createAssets()"
                      >
                        Add Asset
                      </button>
                    </span>
                    <button
                      class="default_btn"
                      mat-raised-button
                      type="button"
                      (click)="cancelButton()"
                    >
                      Cancel
                    </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
